export const DEFAULT_CHART_COLORS = [
  'var(--diagram-color-blue-100)',
  'var(--diagram-color-blue-150)',
  'var(--diagram-color-blue-50)',
  'var(--diagram-color-black)',
  'var(--diagram-color-greenblue-100)',
] as const;

/** Okabe-Ito colours with at least 3:1 contrast against white. */
export const DEFAULT_PIE_CHART_COLORS = [
  'var(--chart-color-blue)',
  'var(--chart-color-vermillion)',
  'var(--chart-color-bluish-green)',
  'var(--chart-color-reddish-purple)',
  'var(--chart-color-black)',
] as const;

export const SYNTHETIC_POINT_SUFFIX = '__isSynthetic' as const;

/**
 * Synthetic points only exist to stretch a single measurement into a line.
 * They are never drawn, never listed in the tooltip and never in the data
 * table.
 */
export function isSyntheticPoint(payload: unknown): boolean {
  if (!payload || typeof payload !== 'object') {
    return false;
  }

  return Boolean(
    (payload as Record<string, unknown>)?.[SYNTHETIC_POINT_SUFFIX],
  );
}

export function resolveChartColor(color: string | undefined, index: number) {
  return color || DEFAULT_CHART_COLORS[index % DEFAULT_CHART_COLORS.length];
}

export function resolvePieChartColor(color: string | undefined, index: number) {
  return (
    color || DEFAULT_PIE_CHART_COLORS[index % DEFAULT_PIE_CHART_COLORS.length]
  );
}
